import React from 'react';
import AdditionalFunctionalities from './AdditionalFunctionalities';

const AdditionalFunctionalitiesContainer = () => {
  return <AdditionalFunctionalities />;
};

export default React.memo(AdditionalFunctionalitiesContainer);
